import React, {useContext, useEffect, useState} from "react";
import {
    TextField,
    Typography,
    Button, Menu, MenuItem, FormControlLabel, Checkbox, Tab, Paper, InputAdornment, FormControl, Select,
} from "@mui/material";

import Box from "@mui/material/Box";
import currencyList from "../../sampleData/currencyList";
import usePA_GlobalStore from "../../Services/ZustandGlobalStore";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import {capitalizeFirstLetter} from "../Helpers/TextStyling";
import Divider from "@mui/material/Divider";
import {PAContext} from "../../Services/PAContext";

const CATEGORY_LABELS = {
    lodging: "Lodging (per night)",
    meals: "Meals (per day)",
    activities: "Activities (per activity)",
    flights: "Flights",
    supplies: "Supplies",
    incidentals: "Incidentals",
    transportation: "Transportation",
    shopping: "Shopping"
};

const glassPanelStyle = {
    background: 'rgba(255, 255, 255, 0.45)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    borderRadius: '16px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.06)',
    p: 3,
    mb: 3
};
const glassInputStyle = {
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        borderRadius: '10px',
        backdropFilter: 'blur(5px)',
        transition: 'all 0.2s ease-in-out',
        '& fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.4)',
        },
        '&:hover fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.8)',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'primary.main',
            borderWidth: '1.5px'
        },
        '&.Mui-disabled': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.1)' }
        }
    }
};
const glassSelectStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '10px',
    backdropFilter: 'blur(5px)',
    transition: 'all 0.2s ease-in-out',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.4)'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.8)'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
        borderWidth: '1.5px'
    },
    '&.Mui-disabled': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 255, 255, 0.1)'
        }
    }
};


function UnifiedBudgetBusinessAuthorization() {

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();
    const { sendSocketMessage } = useContext(PAContext);

    // At the top of your component code block:
    const isSyncing = usePA_GlobalStore((state) => state.isSyncing);
    const showCloudSuccess = usePA_GlobalStore((state) => state.showCloudSuccess);

    const [anchorChangeCurrencyEl, setAnchorChangeCurrencyEl] = useState(null);

    const [eventTotalLimit, setEventTotalLimit] = useState(0);
    const [dailyLimit, setDailyLimit] = useState(0);
    const [expenseCurrency, setExpenseCurrency] = useState('USD');

    // **Category-Based Limits**
    const [categoryMode, setCategoryMode] = useState("same"); // "same" or "custom"

    const [useLodgingLimit, setUseLodgingLimit] = useState(false);
    const [lodgingLimit, setLodgingLimit] = useState("");
    const [lodgingUnit, setLodgingUnit] = useState("Each Night");

    const [useFlightLimit, setUseFlightLimit] = useState(false);
    const [flightLimit, setFlightLimit] = useState("");
    const [flightUnit, setFlightUnit] = useState("Each Direction");

    const [useActivityLimit, setUseActivityLimit] = useState(false);
    const [activityLimit, setActivityLimit] = useState("");
    const [activityUnit, setActivityUnit] = useState("Each Activity");

    const [useMealLimit, setUseMealLimit] = useState(false);
    const [mealLimit, setMealLimit] = useState("");
    const [mealUnit, setMealUnit] = useState("Each Meal");

    const [useSuppliesLimit, setUseSuppliesLimit] = useState(false);
    const [suppliesLimit, setSuppliesLimit] = useState("");
    const [suppliesUnit, setSuppliesUnit] = useState("For Entire Event");

    const [useIncidentalsLimit, setUseIncidentalsLimit] = useState(false);
    const [incidentalsLimit, setIncidentalsLimit] = useState("");
    const [incidentalsUnit, setIncidentalsUnit] = useState("Each Receipt");

    const [useShoppingLimit, setUseShoppingLimit] = useState(false);
    const [shoppingLimit, setShoppingLimit] = useState("");
    const [shoppingUnit, setShoppingUnit] = useState("For Entire Event");

    const [useTransportationLimit, setUseTransportationLimit] = useState(false);
    const [transportationLimit, setTransportationLimit] = useState("");
    const [transportationUnit, setTransportationUnit] = useState("Each Receipt");

    // Individual Attendee Limits
    const [individualLimits, setIndividualLimits] = useState(
        PA_GlobalObject?.Planning?.attendees?.reduce((acc, attendee) => {
            acc[attendee.id] = {
                lodging: "", lodging_unit: "Each Night",
                flights: "", flights_unit: "Each Direction",
                activities: "", activities_unit: "Each Activity",
                meals: "", meals_unit: "Each Meal",
                supplies: "", supplies_unit: "For Entire Event",
                incidentals: "", incidentals_unit: "Each Receipt",
                shopping: "", shopping_unit: "For Entire Event",
                transportation: "", transportation_unit: "Each Receipt"
            };
            return acc;
        }, {}) || {}
    );

    useEffect(() => {
        const businessAuth = usePA_GlobalStore.getState().PA_GlobalObject.Planning?.business_authorizations || {};

        console.log("!!!!! businessAuth : ", businessAuth);

        setEventTotalLimit(businessAuth.eventTotalLimit || 0);
        setDailyLimit(businessAuth.dailyLimit || 0);
        setExpenseCurrency(businessAuth.currency || "USD");
        setCategoryMode(businessAuth.categoryMode || "same");

        // Load Category Limits & Units
        setUseLodgingLimit(businessAuth.categoryLimits?.lodging !== null && businessAuth.categoryLimits?.lodging !== undefined);
        setLodgingLimit(businessAuth.categoryLimits?.lodging || "");
        setLodgingUnit(businessAuth.categoryUnits?.lodging || "Each Night");

        setUseFlightLimit(businessAuth.categoryLimits?.flights !== null && businessAuth.categoryLimits?.flights !== undefined);
        setFlightLimit(businessAuth.categoryLimits?.flights || "");
        setFlightUnit(businessAuth.categoryUnits?.flights || "Each Direction");

        setUseActivityLimit(businessAuth.categoryLimits?.activities !== null && businessAuth.categoryLimits?.activities !== undefined);
        setActivityLimit(businessAuth.categoryLimits?.activities || "");
        setActivityUnit(businessAuth.categoryUnits?.activities || "Each Activity");

        setUseMealLimit(businessAuth.categoryLimits?.meals !== null && businessAuth.categoryLimits?.meals !== undefined);
        setMealLimit(businessAuth.categoryLimits?.meals || "");
        setMealUnit(businessAuth.categoryUnits?.meals || "Each Meal");

        setUseSuppliesLimit(!!businessAuth.categoryLimits?.supplies);
        setSuppliesLimit(businessAuth.categoryLimits?.supplies || "");
        setSuppliesUnit(businessAuth.categoryUnits?.supplies || "For Entire Event");

        setUseIncidentalsLimit(businessAuth.categoryLimits?.incidentals !== null && businessAuth.categoryLimits?.incidentals !== undefined);
        setIncidentalsLimit(businessAuth.categoryLimits?.incidentals || "");
        setIncidentalsUnit(businessAuth.categoryUnits?.incidentals || "Each Receipt");

        setUseShoppingLimit(!!businessAuth.categoryLimits?.shopping);
        setShoppingLimit(businessAuth.categoryLimits?.shopping || "");
        setShoppingUnit(businessAuth.categoryUnits?.shopping || "For Entire Event");

        setUseTransportationLimit(!!businessAuth.categoryLimits?.transportation);
        setTransportationLimit(businessAuth.categoryLimits?.transportation || "");
        setTransportationUnit(businessAuth.categoryUnits?.transportation || "Each Receipt");

        // Load Individual Attendee Limits
        if (businessAuth.individualLimits) {
            setIndividualLimits(businessAuth.individualLimits);
        } else {
            const defaultLimits = (PA_GlobalObject?.Planning?.attendees || []).reduce((acc, attendee) => {
                acc[attendee.id] = {
                    lodging: "", lodging_unit: "Each Night",
                    flights: "", flights_unit: "Each Direction",
                    activities: "", activities_unit: "Each Activity",
                    meals: "", meals_unit: "Each Meal",
                    supplies: "", supplies_unit: "For Entire Event",
                    incidentals: "", incidentals_unit: "Each Receipt",
                    shopping: "", shopping_unit: "For Entire Event",
                    transportation: "", transportation_unit: "Each Receipt"
                };
                return acc;
            }, {});
            setIndividualLimits(defaultLimits);
        }
    }, []);

    useEffect(() => {
        console.log("individualLimits has been updated : ", individualLimits);
    }, [individualLimits]);

    // Handle Tab Change (Same vs Custom)
    const handleTabChange = (event, newValue) => {
        setCategoryMode(newValue);
    };

    // Handle Individual Attendee Limit and Unit Change
    const handleIndividualLimitChange = (attendeeId, key, type, value) => {
        // type parameter handles switching either amount values or unit options independently
        setIndividualLimits((prev) => {
            const updatedUser = { ...prev[attendeeId] };
            if (type === 'amount') {
                updatedUser[key] = value;
            } else {
                updatedUser[`${key}_unit`] = value;
            }
            return {
                ...prev,
                [attendeeId]: updatedUser
            };
        });
    };

    const openChangeCurrency = Boolean(anchorChangeCurrencyEl);
    const handleOpenChangeCurrency = (event) => {
        setAnchorChangeCurrencyEl(event.currentTarget);
    };
    const handleChangeCurrencyClick = (event, code) => {
        console.log("changing currency to : " + code);
        setExpenseCurrency(code);
        handleChangeCurrencyClose();
    };
    const handleChangeCurrencyClose = () => {
        setAnchorChangeCurrencyEl(null);
    };

    const saveBusinessAuthorizations = () => {

        const store = usePA_GlobalStore.getState();
        store.startSyncing();

        // 1. Build the object first so both the store setter and socket action can read it
        const businessAuthPayload = {
            eventTotalLimit: Number(eventTotalLimit) || 0,
            dailyLimit: Number(dailyLimit) || 0,
            currency: expenseCurrency,
            categoryMode,

            // **Category-Based Limits**
            categoryLimits: {
                lodging: useLodgingLimit ? Number(lodgingLimit) || 0 : null,
                flights: useFlightLimit ? Number(flightLimit) || 0 : null,
                activities: useActivityLimit ? Number(activityLimit) || 0 : null,
                meals: useMealLimit ? Number(mealLimit) || 0 : null,
                supplies: useSuppliesLimit ? Number(suppliesLimit) || 0 : null,
                incidentals: useIncidentalsLimit ? Number(incidentalsLimit) || 0 : null,
                shopping: useShoppingLimit ? Number(shoppingLimit) || 0 : null,
                transportation: useTransportationLimit ? Number(transportationLimit) || 0 : null,
            },

            // **Unified Category Budget Units Mapping**
            categoryUnits: {
                lodging: lodgingUnit,
                flights: flightUnit,
                activities: activityUnit,
                meals: mealUnit,
                supplies: suppliesUnit,
                incidentals: incidentalsUnit,
                shopping: shoppingUnit,
                transportation: transportationUnit
            },

            // **Individual Attendee Limits & Unit Options**
            individualLimits: Object.keys(individualLimits).reduce((acc, attendeeId) => {
                acc[attendeeId] = {
                    lodging: individualLimits[attendeeId].lodging ? Number(individualLimits[attendeeId].lodging) : null,
                    lodging_unit: individualLimits[attendeeId].lodging_unit || "Each Night",
                    flights: individualLimits[attendeeId].flights ? Number(individualLimits[attendeeId].flights) : null,
                    flights_unit: individualLimits[attendeeId].flights_unit || "Each Direction",
                    activities: individualLimits[attendeeId].activities ? Number(individualLimits[attendeeId].activities) : null,
                    activities_unit: individualLimits[attendeeId].activities_unit || "Each Activity",
                    meals: individualLimits[attendeeId].meals ? Number(individualLimits[attendeeId].meals) : null,
                    meals_unit: individualLimits[attendeeId].meals_unit || "Each Meal",
                    supplies: individualLimits[attendeeId].supplies ? Number(individualLimits[attendeeId].supplies) : null,
                    supplies_unit: individualLimits[attendeeId].supplies_unit || "For Entire Event",
                    incidentals: individualLimits[attendeeId].incidentals ? Number(individualLimits[attendeeId].incidentals) : null,
                    incidentals_unit: individualLimits[attendeeId].incidentals_unit || "Each Receipt",
                    shopping: individualLimits[attendeeId].shopping ? Number(individualLimits[attendeeId].shopping) : null,
                    shopping_unit: individualLimits[attendeeId].shopping_unit || "For Entire Event",
                    transportation: individualLimits[attendeeId].transportation ? Number(individualLimits[attendeeId].transportation) : null,
                    transportation_unit: individualLimits[attendeeId].transportation_unit || "Each Receipt",
                };
                return acc;
            }, {}),
        };

        // 2. Set your local Zustand Global store
        set_PA_GlobalObject((prev) => {
            return {
                Planning: {
                    ...prev.Planning,
                    business_authorizations: businessAuthPayload,
                },
            };
        });

        // 3. Emit backend update via socket stream if the event state allows it
        if (PA_GlobalObject?.Planning?.status !== 10) {
            const _sendString = {
                action: "E_updateEventBusinessAuthorizations",
                event_id: PA_GlobalObject?.Planning?.id,
                business_authorizations: businessAuthPayload // Now cleanly assigned
            };

            sendSocketMessage(_sendString);
        } else {
            // Fallback for mock environment simulation or locked status values
            setTimeout(() => store.triggerSyncSuccess(), 500);
        }
    };

    return (

        <Box sx={{ p: { xs: 1, sm: 2 } }}>

            {/* Header Control Panel */}
            <Box display="flex" justifyContent="flex-end" alignItems="center" mb={3}>
                <Button
                    onClick={saveBusinessAuthorizations}
                    disabled={isSyncing}
                    color={showCloudSuccess ? "success" : "primary"}
                    variant="contained"
                    size="medium"
                    sx={{
                        borderRadius: '10px',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3,
                        minWidth: '130px',
                        transition: 'all 0.2s ease-in-out',
                        boxShadow: showCloudSuccess
                            ? '0 4px 14px rgba(46, 125, 50, 0.3)'
                            : '0 4px 14px rgba(25, 118, 210, 0.3)',
                        backgroundColor: showCloudSuccess ? 'success.main' : 'primary.main',
                        '&:hover': {
                            backgroundColor: showCloudSuccess ? 'success.dark' : 'primary.dark',
                        }
                    }}
                >
                    {isSyncing && "Saving..."}
                    {showCloudSuccess && "✓ Saved!"}
                    {!isSyncing && !showCloudSuccess && "Save"}
                </Button>
            </Box>

            {/* Panel 1: Master Currency Configuration */}
            <Paper sx={glassPanelStyle} elevation={0}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                            Base Rules Currency
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                            Applies uniform conversion standards across limits.
                        </Typography>
                    </Box>
                    <Button
                        id="long-button"
                        aria-controls={openChangeCurrency ? 'long-menu' : undefined}
                        aria-expanded={openChangeCurrency ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleOpenChangeCurrency}
                        variant="outlined"
                        size="small"
                        sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderColor: 'rgba(0,0,0,0.12)',
                            color: 'text.primary',
                            backgroundColor: 'rgba(255,255,255,0.4)'
                        }}
                    >
                        {expenseCurrency} ▾
                    </Button>
                    <Menu
                        id="long-menu"
                        anchorEl={anchorChangeCurrencyEl}
                        open={openChangeCurrency}
                        onClose={handleChangeCurrencyClose}
                        PaperProps={{
                            sx: {
                                background: 'rgba(255, 255, 255, 0.85)',
                                backdropFilter: 'blur(15px)',
                                border: '1px solid rgba(255,255,255,0.4)',
                                borderRadius: '12px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
                            }
                        }}
                    >
                        {currencyList.map((option) => (
                            <MenuItem
                                key={option.code}
                                selected={option.code === PA_GlobalObject.Planning?.['budget_currency']}
                                onClick={(e) => handleChangeCurrencyClick(e, option.code)}
                                sx={{ fontSize: '13px', px: 2 }}
                            >
                                <strong>{option.code}</strong> &nbsp;•&nbsp; {option.name}
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
            </Paper>

            {/* Panel 2: Global & Daily Allowances */}
            <Paper sx={glassPanelStyle} elevation={0}>
                {/* Event Total Allowance */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>Event Authorization</Typography>
                    <TextField
                        size="small"
                        variant="outlined"
                        value={eventTotalLimit}
                        onChange={(e) => setEventTotalLimit(e.target.value)}
                        sx={{ width: "140px", ...glassInputStyle }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end"><Typography variant="caption" sx={{fontWeight:700}}>{expenseCurrency}</Typography></InputAdornment>,
                        }}
                    />
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 3, pl: 0.5 }}>
                    The maximum authorized budget allocation allocated per person for items designated as authorized company
                    operations over the course of the Event. Currently assigned: <strong>{eventTotalLimit ? Number(eventTotalLimit).toLocaleString() : "0"} {expenseCurrency}</strong> per attendee.
                </Typography>

                <Divider sx={{ my: 2, borderColor: 'rgba(0,0,0,0.06)' }} />

                {/* Daily Cap Allowance */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>Daily Spending Ceiling</Typography>
                    <TextField
                        size="small"
                        variant="outlined"
                        value={dailyLimit}
                        onChange={(e) => setDailyLimit(e.target.value)}
                        sx={{ width: "140px", ...glassInputStyle }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end"><Typography variant="caption" sx={{fontWeight:700}}>{expenseCurrency}</Typography></InputAdornment>,
                        }}
                    />
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{ pl: 0.5 }}>
                    Individual rolling daily parameters assigned per person covering <strong>Meals, Activities, and Incidentals</strong>. Currently set to: <strong>{dailyLimit ? Number(dailyLimit).toLocaleString() : "0"} {expenseCurrency}</strong> daily.
                </Typography>
            </Paper>

            {/* Panel 3: Fine-Tuned Category Allocations */}
            <Paper sx={glassPanelStyle} elevation={0}>
                {/* Responsive Header Box: Columns on Mobile, Row on Desktop */}
                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                    gap={2}
                    mb={2}
                >
                    <Box>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>Category Scope Caps</Typography>
                        <Typography variant="caption" color="textSecondary">
                            Toggle individual category structures across uniform or unique profiles.
                        </Typography>
                    </Box>

                    <TabContext value={categoryMode}>
                        <TabList
                            onChange={handleTabChange}
                            aria-label="Category Limits Mode"
                            sx={{
                                minHeight: "34px",
                                background: 'rgba(0,0,0,0.04)',
                                borderRadius: '10px',
                                p: '3px',
                                alignSelf: { xs: 'flex-start', sm: 'auto' }, // Keeps layout clean on narrow mobile viewports
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    height: '100%',
                                    bottom: 0,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    zIndex: 1
                                }
                            }}
                        >
                            <Tab label="Same" value="same" sx={{ fontSize: "12px", minHeight: "28px", padding: "4px 12px", textTransform:'none', fontWeight: 600, zIndex: 2, '&.Mui-selected': { color: 'primary.main' } }} />
                            <Tab label="Custom" value="custom" sx={{ fontSize: "12px", minHeight: "28px", padding: "4px 12px", textTransform:'none', fontWeight: 600, zIndex: 2, '&.Mui-selected': { color: 'primary.main' } }} />
                        </TabList>
                    </TabContext>
                </Box>

                <Box sx={{ mt: 3 }}>
                    {/* SAME LIMITS SECTION */}
                    {categoryMode === "same" && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            {[
                                { label: "Lodging", state: useLodgingLimit, setState: setUseLodgingLimit, value: lodgingLimit, setValue: setLodgingLimit, unit: lodgingUnit, setUnit: setLodgingUnit, options: ["Each Night", "For Entire Event"] },
                                { label: "Flights", state: useFlightLimit, setState: setUseFlightLimit, value: flightLimit, setValue: setFlightLimit, unit: flightUnit, setUnit: setFlightUnit, options: ["Each Direction", "For Entire Event"] },
                                { label: "Activities", state: useActivityLimit, setState: setUseActivityLimit, value: activityLimit, setValue: setActivityLimit, unit: activityUnit, setUnit: setActivityUnit, options: ["Each Activity", "For Entire Event"] },
                                { label: "Meals", state: useMealLimit, setState: setUseMealLimit, value: mealLimit, setValue: setMealLimit, unit: mealUnit, setUnit: setMealUnit, options: ["Each Meal", "Each Day", "For Entire Event"] },
                                { label: "Supplies", state: useSuppliesLimit, setState: setUseSuppliesLimit, value: suppliesLimit, setValue: setSuppliesLimit, unit: suppliesUnit, setUnit: setSuppliesUnit, options: ["Each Day", "For Entire Event", "Each Receipt"] },
                                { label: "Incidentals", state: useIncidentalsLimit, setState: setUseIncidentalsLimit, value: incidentalsLimit, setValue: setIncidentalsLimit, unit: incidentalsUnit, setUnit: setIncidentalsUnit, options: ["Each Day", "For Entire Event", "Each Receipt"] },
                                { label: "Transportation", state: useTransportationLimit, setState: setUseTransportationLimit, value: transportationLimit, setValue: setTransportationLimit, unit: transportationUnit, setUnit: setTransportationUnit, options: ["Each Day", "For Entire Event", "Each Receipt"] },
                                { label: "Shopping", state: useShoppingLimit, setState: setUseShoppingLimit, value: shoppingLimit, setValue: setShoppingLimit, unit: shoppingUnit, setUnit: setShoppingUnit, options: ["Each Day", "For Entire Event", "Each Receipt"] },
                            ].map((item, index) => (
                                <Box
                                    key={index}
                                    display="flex"
                                    flexDirection={{ xs: 'column', sm: 'row' }}
                                    justifyContent="space-between"
                                    alignItems={{ xs: 'stretch', sm: 'center' }}
                                    gap={1.5}
                                    sx={{
                                        p: { xs: 2, sm: 1.5 },
                                        borderRadius: '12px',
                                        transition: 'all 0.2s ease-in-out',

                                        // 🟢 INCREASED CONTRAST BACKGROUNDS
                                        backgroundColor: item.state
                                            ? '#ffffff' // Pure solid white for active cards to pop out
                                            : 'rgba(0, 0, 0, 0.02)', // Slightly darker tint for disabled cards

                                        // 🟢 DEFINE CARDS WITH HIGHER CONTRAST BORDERS
                                        border: item.state
                                            ? '1px solid rgba(0, 0, 0, 0.12)' // Darker, crisp outline when active
                                            : '1px solid rgba(0, 0, 0, 0.05)', // Fainter layout line when off

                                        // 🟢 SHADOW SEPARATION FOR ACTIVE ITEMS
                                        boxShadow: item.state
                                            ? '0 4px 16px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.02)'
                                            : 'none',
                                    }}
                                >
                                    {/* --- LINE 1: Label & Checkbox --- */}
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        width={{ xs: '100%', sm: '160px' }}
                                        flexShrink={0}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: item.state ? 'text.primary' : 'text.disabled',
                                                fontWeight: item.state ? 600 : 400
                                            }}
                                        >
                                            {item.label}
                                        </Typography>

                                        <Box display={{ xs: 'block', sm: 'none' }}>
                                            <FormControlLabel
                                                sx={{ mr: 0, ml: 0 }}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={item.state}
                                                        onChange={(e) => item.setState(e.target.checked)}
                                                    />
                                                }
                                                label=""
                                            />
                                        </Box>
                                    </Box>

                                    {/* --- LINE 2: Text Input --- */}
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        disabled={!item.state}
                                        placeholder="0.00"
                                        value={item.value}
                                        onChange={(e) => item.setValue(e.target.value)}
                                        sx={{
                                            width: { xs: '100%', sm: '75px' },
                                            flexShrink: 0,
                                            ...glassInputStyle,
                                            // Override background to show standard disabled styling clearly
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: item.state ? 'transparent' : 'rgba(0,0,0,0.03)'
                                            }
                                        }}
                                        inputProps={{ maxLength: 4 }}
                                    />

                                    {/* --- LINE 3: Dropdown Menu Selection --- */}
                                    <FormControl size="small" disabled={!item.state} sx={{ flexGrow: 1, width: '100%', minWidth: { sm: '155px' } }}>
                                        <Select
                                            value={item.unit}
                                            onChange={(e) => item.setUnit(e.target.value)}
                                            sx={{
                                                width: "100%",
                                                fontSize: '13px',
                                                ...glassSelectStyle,
                                                backgroundColor: item.state ? 'transparent' : 'rgba(0,0,0,0.03)'
                                            }}
                                            MenuProps={{ PaperProps: { sx: { backdropFilter: 'blur(10px)', backgroundColor: 'rgba(255,255,255,0.9)' } } }}
                                        >
                                            {item.options.map((opt) => (
                                                <MenuItem key={opt} value={opt} sx={{ fontSize: '13px' }}>{opt}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    {/* Desktop-Only Checkbox */}
                                    <Box display={{ xs: 'none', sm: 'block' }}>
                                        <FormControlLabel
                                            sx={{ mr: 0, ml: 0.5 }}
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={item.state}
                                                    onChange={(e) => item.setState(e.target.checked)}
                                                />
                                            }
                                            label=""
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    )}


                    {/* CUSTOM LIMITS SECTION */}
                    {categoryMode === "custom" && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            {PA_GlobalObject?.Planning?.attendees
                                ?.filter((attendee) => attendee.role !== "planner" && attendee.status !== 4)
                                ?.map((attendee) => (
                                    <Box
                                        key={attendee.id}
                                        sx={{
                                            p: { xs: 1.5, sm: 2 }, // Slightly padded less inside small viewport screens
                                            backgroundColor: 'rgba(255,255,255,0.25)',
                                            borderRadius: '12px',
                                            border: '1px solid rgba(255,255,255,0.3)'
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ fontWeight: 700, color: 'primary.dark', mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: 'primary.main' }} />
                                            {capitalizeFirstLetter(attendee.fname)} {capitalizeFirstLetter(attendee.lname)}
                                        </Typography>

                                        {Object.entries(CATEGORY_LABELS).map(([key, label], subIdx) => {
                                            const options = ["lodging", "flights", "activities", "meals"].includes(key)
                                                ? (key === "meals" ? ["Each Meal", "Each Day", "For Entire Event"] : [`Each ${key === 'flights' ? 'Direction' : key === 'lodging' ? 'Night' : 'Activity'}`, "For Entire Event"])
                                                : ["Each Day", "For Entire Event", "Each Receipt"];

                                            const currentUnitValue = individualLimits[attendee.id]?.[`${key}_unit`] || options[0];

                                            return (
                                                <Box
                                                    key={key}
                                                    display="flex"
                                                    flexDirection={{ xs: 'column', sm: 'row' }} // Stacks text label above inputs on mobile viewport width
                                                    justifyContent="space-between"
                                                    alignItems={{ xs: 'stretch', sm: 'center' }}
                                                    gap={{ xs: 0.5, sm: 2 }}
                                                    sx={{
                                                        py: 1,
                                                        borderBottom: subIdx !== Object.keys(CATEGORY_LABELS).length - 1 ? '1px solid rgba(0,0,0,0.02)' : 'none'
                                                    }}
                                                >
                                                    <Typography variant="caption" color="textSecondary" sx={{ pl: { xs: 0, sm: 1 }, width: { xs: '100%', sm: '130px' }, mb: { xs: 0.5, sm: 0 } }}>
                                                        {label}
                                                    </Typography>

                                                    <Box display="flex" alignItems="center" gap={1} width={{ xs: '100%', sm: 'auto' }}>
                                                        {/* Attendee Budget Limit Amount Input */}
                                                        <TextField
                                                            size="small"
                                                            variant="outlined"
                                                            value={individualLimits[attendee.id]?.[key] || ""}
                                                            onChange={(e) => handleIndividualLimitChange(attendee.id, key, 'amount', e.target.value)}
                                                            sx={{ width: { xs: '80px', sm: '100px' }, ...glassInputStyle }}
                                                            inputProps={{ style: { fontSize: '12px', padding: '6px 10px' } }}
                                                        />

                                                        {/* Attendee Budget Unit Selection Dropdown */}
                                                        <FormControl size="small" sx={{ flexGrow: { xs: 1, sm: 0 } }}>
                                                            <Select
                                                                value={currentUnitValue}
                                                                onChange={(e) => handleIndividualLimitChange(attendee.id, key, 'unit', e.target.value)}
                                                                sx={{ width: '100%', minWidth: { sm: '145px' }, height: '28px', fontSize: '11px', ...glassSelectStyle }}
                                                            >
                                                                {options.map((opt) => (
                                                                    <MenuItem key={opt} value={opt} sx={{ fontSize: '12px' }}>{opt}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                ))
                            }
                        </Box>
                    )}
                </Box>
            </Paper>
        </Box>

    );
}


export default UnifiedBudgetBusinessAuthorization;
